import { B2C_ECOMMERCE_TYPES, WL_ECOMMERCE_TYPES } from '../constants/subscription-type';

const ECOMMERCE_TYPES = [...B2C_ECOMMERCE_TYPES, ...WL_ECOMMERCE_TYPES];

const isEcommercePlanType = (type: string): boolean =>
  ECOMMERCE_TYPES.some((ecommerceType) => ecommerceType === type);

export default isEcommercePlanType;
